import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us-business',
  templateUrl: './about-us-business.component.html',
  styleUrls: ['./about-us-business.component.scss']
})
export class AboutUsBusinessComponent implements OnInit {

  data = [
    {
      img: 'assets/img/culture.png',
      header: 'Culture of Care',
      description: 'Investments in mental health enhance the company’s employer brand. Demonstrating care for employees boosts loyalty. Reduces stress and burnout. Improves team effectiveness. Decreases employee turnover.',
      num: '01'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Ease of Integration',
      description: 'Anima integrates seamlessly into your internal processes. Online screening with minimal disruption to employees\' workdays. Flexible for companies with hybrid or remote work formats. Easily scalable for organizations of any size.',
      num: '02'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Confidentiality and Security',
      description: 'Anima places a high priority on confidentiality. We do not use any personal data.\n' +
          'With a strict focus on privacy, Anima only utilizes the camera for gaze detection, recording only gaze coordinates. There are no videos or images stored, and stringent data protection protocols are in place to safeguard personal information.',
      num: '03'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Scientific Accuracy',
      description: 'Anima combines cutting-edge eye-tracking technology with well-established psychometric tests to analyze attention biomarkers. This unique combination of technology and science enables highly accurate assessments (80-93%) of mental states such as anxiety, depression, burnout, and stress levels—even in cases where self-assessment may be unreliable.',
      num: '04'
    }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
